import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

// Design System
import { TertiaryButton } from 'jl-design-system/elements/button/Button';

// Types
import { AppDispatch } from 'types/RootState.types';
import { EditDetailsLinkProps } from './EditDetailsLink.types';

// Config
import editDetailsLinkState from './EditDetailsLink.state';
import routeConstants from '@constants/routeConstants';
import { useWindowSize } from '@context/window/WindowSizeContext';

// Styles
import styles from './edit-details-link.scss';

const EditDetailsLink = ({ routerActions = { push } }: EditDetailsLinkProps) => {
  const dispatch: AppDispatch = useDispatch();
  const { isClickCollectOrder, paymentProcessing } = useSelector(editDetailsLinkState);
  const { isSmallMobile } = useWindowSize();

  const onClickHandler = () => {
    const url = isClickCollectOrder ? routeConstants.CLICK_AND_COLLECT_STORE_SELECTED : routeConstants.DELIVERY;
    dispatch(routerActions.push(url));
  };

  const editSuffix = isSmallMobile ? '' : isClickCollectOrder ? ' collection details' : ' delivery details';

  return (
    <TertiaryButton
      className={styles.button}
      data-testid="order-details-edit-link"
      disabled={paymentProcessing}
      onClick={onClickHandler}
      small
    >
      {`Edit${editSuffix}`}
    </TertiaryButton>
  );
};

export default EditDetailsLink;
